import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { LENDERS_ROUTES } from "app/lenders/lenders.routing";
import { LendersService } from 'app/lenders/services/lenders.service';
import { LendersListComponent } from 'app/lenders/component/lenders-list/lenders-list.component';
import { CoreModule } from 'app/core/core.module';
import { LendersAddComponent } from 'app/lenders/component/lenders-add/lenders-add.component';
import { LendersEditComponent } from 'app/lenders/component/lenders-edit/lenders-edit.component';
import { LendersCompanyComponent } from 'app/lenders/component/lenders-company/lenders-company.component';
import { LendersUserAuditModulesComponent } from './component/lenders-user-audit-modules/lenders-user-audit-modules.component';
import { LenderAuditModuleViewComponent } from './component/lender-audit-module-view/lender-audit-module-view.component';
import { LendersContactComponent } from './component/lenders-contact/lenders-contact.component';

@NgModule({
	imports: [
        CoreModule,
        SharedModule,
        RouterModule.forChild(LENDERS_ROUTES)
	],
    declarations: [
        LendersListComponent,
        LendersAddComponent,
        LendersEditComponent,
        LendersCompanyComponent,
        LendersUserAuditModulesComponent,
        LenderAuditModuleViewComponent,
        LendersContactComponent
    ],
    providers: [LendersService]
})
export class LendersModule { }
